import Axios from 'api/client';
import { Import, ImportObjectType, ImportType } from 'types/domain';

interface ImportRequestParams {
    draft_id?: number;
    sheet_id: string;
    file_id: string | null;
    workbook_id: string;
    space_id: string;
    type: ImportType;
    rows: number;
    file_name: string | null;
    object_id?: number;
    object_type?: ImportObjectType;
}

interface DraftImportRequestParams {
    space_id: string;
    type: ImportType;
}

const createImport = (accountId: number, params: ImportRequestParams) =>
    Axios.post<Import>(`/accounts/${accountId}/import-flatfile`, params).then(
        response => response.data,
    );

const createImportDraft = (accountId: number, params: DraftImportRequestParams) =>
    Axios.post(`/accounts/${accountId}/draft-flatfile`, params).then(response => response.data);

const getSpaceToken = (accountId: number, reportId: number) =>
    Axios.get(`/accounts/${accountId}/imports/${reportId}/space`).then(response => response.data);

export type { ImportRequestParams, DraftImportRequestParams };
export { createImport, createImportDraft, getSpaceToken };
